<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span>工单信息</span>
        <el-button type="text" class="float-right" @click="$router.go(-1)">返回</el-button>
      </div>

      <!-- 显示工单ID -->
      <el-form :model="form" inline>
        <el-form-item label="工单ID">
          <el-input v-model="form.TicketId" disabled />
        </el-form-item>
      </el-form>

      <!-- 数据表格 -->
      <el-table
        v-if="ticketData.length"
        :data="ticketData"
        border
        style="margin-top: 20px"
      >
        <el-table-column prop="AssetId" label="资产ID" width="150" />
        <el-table-column prop="IdcpName" label="源机房" />
        <el-table-column prop="OppositeIdcpName" label="目的机房" />
        <el-table-column prop="LogisticsNum" label="物流单号" width="180" />
        <el-table-column prop="Model" label="型号" />
        <el-table-column prop="ServerHeight" label="高度(U)" width="80" />
        <el-table-column prop="TaskStatus" label="任务状态" width="100" />
      </el-table>
      <el-empty v-else description="暂无数据" />
    </el-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      form: {
        TicketId: "", // 工单ID
      },
      ticketData: [], // 工单数据
    };
  },
  created() {
    // 获取路由参数并自动查询
    const ticketId = this.$route.query.TicketId;
    if (ticketId) {
      this.form.TicketId = ticketId; // 设置工单ID
      this.fetchTicketInfo(); // 自动查询
    } else {
      this.$message.error("未提供有效的工单ID！");
    }
  },
  methods: {
    async fetchTicketInfo() {
      if (!this.form.TicketId) {
        this.$message.error("工单ID为空！");
        return;
      }

      try {
        const response = await axios.post(
          "/api/v1/ops/get_ticket_info",
          { TicketId: this.form.TicketId }
        );
        if (response.data.status === 0) {
          this.ticketData = response.data.data;
          this.$message.success("查询成功！");
        } else {
          this.ticketData = [];
          this.$message.error(response.data.msg || "查询失败！");
        }
      } catch (error) {
        console.error("请求失败：", error);
        this.ticketData = [];
        this.$message.error("服务器异常，请稍后重试！");
      }
    },
  },
};
</script>

<style scoped>
.el-card {
  padding: 20px;
}
.float-right {
  float: right;
}
</style>
